import { CampaignType } from '../../../../constants/marketingCampaign'
import { BuildFormValuesContext } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { FreeDeliveryRuleState } from './types'

export function buildFreeDeliveryFormValues(
	ctx: BuildFormValuesContext<FreeDeliveryRuleState>,
): Record<string, unknown> {
	const { rule, confirmation, selectedShopIds, campaignMeta, marketingCampaignKey } = ctx
	const base: Record<string, unknown> = {
		startDate: confirmation.startDate,
		startTime: confirmation.startTime,
		discount: null,
		threshold: rule.threshold,
		type: CampaignType.FREE_DELIVERY_AFTER_THRESHOLD,
		shopIds: selectedShopIds,
		valueType: campaignMeta.valueType,
		marketingCampaignKey,
		orderTypes: ['delivery'],
		isPermanent: confirmation.isPermanent,
	}

	if (!confirmation.isPermanent) {
		base.endDate = confirmation.endDate
		base.endTime = confirmation.endTime
	}

	return base
}
